export enum LogLevel {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR'
}

export interface ILoggerService {
  debug(message: string, data?: any): void;
  info(message: string, data?: any): void;
  warn(message: string, data?: any): void;
  error(message: string, error?: any): void;
  logRepositoryRequest(repositoryName: string, method: string, data?: any): void;
  logRepositoryResponse(repositoryName: string, method: string, duration: number, data?: any): void;
  logRepositoryError(repositoryName: string, method: string, duration: number, error: any): void;
}

export class LoggerService implements ILoggerService {
  private readonly isDebugEnabled: boolean;
  private readonly isRepositoryLoggingEnabled: boolean;

  constructor() {
    this.isDebugEnabled = import.meta.env.VITE_DEBUG === 'true';
    this.isRepositoryLoggingEnabled =
      import.meta.env.VITE_DEBUG === 'true' ||
      import.meta.env.VITE_LOG_REPOSITORY_REQUESTS === 'true';
  }

  debug(message: string, data?: any): void {
    if (!this.isDebugEnabled) return;
    
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [DEBUG] ${message}`;
    
    if (data !== undefined) {
      console.log(logMessage, data);
    } else {
      console.log(logMessage);
    }
  }

  info(message: string, data?: any): void {
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [INFO] ${message}`;
    
    if (data !== undefined) {
      console.log(logMessage, data);
    } else {
      console.log(logMessage);
    }
  }

  warn(message: string, data?: any): void {
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [WARN] ${message}`;
    
    if (data !== undefined) {
      console.warn(logMessage, data);
    } else {
      console.warn(logMessage);
    }
  }

  error(message: string, error?: any): void {
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [ERROR] ${message}`;
    
    if (error !== undefined) {
      console.error(logMessage, error);
    } else {
      console.error(logMessage);
    }
  }

  logRepositoryRequest(repositoryName: string, method: string, data?: any): void {
    if (!this.isRepositoryLoggingEnabled) return;
    
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [DEBUG] [Repository] ${repositoryName}.${method} - Request`;
    
    if (data !== undefined) {
      console.log(logMessage, data);
    } else {
      console.log(logMessage);
    }
  }

  logRepositoryResponse(repositoryName: string, method: string, duration: number, data?: any): void {
    if (!this.isRepositoryLoggingEnabled) return;
    
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [DEBUG] [Repository] ${repositoryName}.${method} - Response (${duration}ms)`;
    
    if (data !== undefined) {
      console.log(logMessage, data);
    } else {
      console.log(logMessage);
    }
  }

  logRepositoryError(repositoryName: string, method: string, duration: number, error: any): void {
    if (!this.isRepositoryLoggingEnabled) return;
    
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [ERROR] [Repository] ${repositoryName}.${method} - Error (${duration}ms)`;
    
    console.error(logMessage, error);
  }
}